<template>
  <div class="main-wrapper">
    <sidebar-navigation :showMobileNavigation="mobileNavigation" @toggleNavClass="toggleNavClass"></sidebar-navigation>
    <div class="home" :class="{'mask': showContact}">
      <Navigation
        @showLayer="toggleLayer"
        @hideLayers="closeLayers"
        :logoPosition="logoPosition"
        @toggleMobileNavigation="toggleMobileNav"
        :toggleClass="addClass"
        :class="{'isBuilding': isBuilding}"
        :is-pass="isPassed"
        :set-index="indexValue"
      ></Navigation>
      <router-view
          v-on:click.native="closeLayers"
          @isPass="isPassedStyle"
          :style="[showAvailability ? {opacity: 0.5} : {opacity: 'unset'}]"
          @setIndex="setIndex"
      ></router-view>
      <availability v-if="showAvailability"></availability>
    </div>
    <contact v-if="showContact" @hideLayers="closeLayers"></contact>
  </div>

</template>

<script>
import Navigation from "../layout/Navigation";
import SidebarNavigation from "../layout/SidebarNavigation";
import Availability from "../pages/Availability";
import Contact from "../pages/Contact";
export default {
    name: "Main",
    data: () => ({
      showAvailability: false,
      showContact: false,
      logoPosition: true,
      mobileNavigation: false,
      addClass: false,
      isBuilding: false,
      isPassed: null,
      indexValue: null
    }),
    components: {
        Navigation,
        Availability,
        Contact,
        SidebarNavigation
    },
    created() {
      if(window.innerWidth > 600) {
        this.showAvailability = false
      }
      window.addEventListener('resize', () => this.showAvailability = false)

      if(this.$route.name === 'building') {
        this.isBuilding = true
      }
    },
    mounted() {
      // if(window.innerWidth > 600 && this.$route.name !== 'building') {
      //   this.setNavigationOpacity(1)
      //   return;
      // }
      // this.setNavigationOpacity(1)

        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);

    },
    methods: {
      isPassedStyle(value) {

        if(value) {
          this.isPassed = 'visible'
        } else {
          this.isPassed = null
        }

      },
      toggleLayer(value) {
        if(value === 'showAvailability') {
          this.showAvailability = true;
          this.showContact = false;
          if(window.innerWidth < 600 && this.$route.name === 'building') {
            return;
          }
          this.isPassed = "visible"
        }

        if(value === 'showContact') {
          this.showContact = true
          this.showAvailability = false;
          this.isPassed = "hidden"
        }

      },
      closeLayers() {
        this.showAvailability = false
        this.showContact = false
        this.isPassed = "visible"
      },

      setNavigationOpacity(value) {
        const navContainer = document.getElementsByClassName('navigation-container');
        const navContainerStyle = navContainer[0].style;
        if(value > 0.76) {
          navContainerStyle.display = 'flex';
        } else {
          navContainerStyle.display = 'none';
        }
        const navIcons = document.getElementsByClassName('navigation-menu-left');
        const navIconStyle = navIcons[0].style;
        navIconStyle.opacity = 1
      },
      toggleMobileNav(value) {
        this.mobileNavigation = value
        if(this.mobileNavigation) {
          this.addClass = true
        } else {
          this.addClass = false
        }
      },
      toggleNavClass(value) {
        this.addClass = value
      },
      setIndex(value) {
        this.indexValue = value
      }
    },
    watch: {
      $route() {

        if(this.$route.name === 'building') {
          this.isBuilding = true
          this.isPassed = null
            document.getElementsByClassName('navigation-menu-right--text')[0].style.display = null
        } else {
          this.isBuilding = false
          this.indexValue = null
          document.getElementsByClassName('navigation-menu-right--text')[0].style.display = 'flex'
        }
      }
    }
 }
</script>

<style scoped>

</style>
